export const AdaptationRuleId = {
  requiredFirst: 'required_first',
  activeForModeFirst: 'active_for_mode_first',
  essentialFirst: 'essential_first',
  essentialThenRequired: 'essential_then_required',
} as const;

export type AdaptationRuleId = (typeof AdaptationRuleId)[keyof typeof AdaptationRuleId];

export const AdaptationDecisionType = {
  /** A candidate reorder is surfaced to the user; nothing is applied until explicit acceptance. */
  propose: 'propose',
  /** No candidate was produced, or the candidate would not change anything observable. */
  abstain: 'abstain',
  /** The user already accepted or rejected this exact proposal for this day; that choice stands. */
  respectPriorChoice: 'respect_prior_choice',
} as const;

export type AdaptationDecisionType = (typeof AdaptationDecisionType)[keyof typeof AdaptationDecisionType];

export const UserChoice = {
  accepted: 'accepted',
  rejected: 'rejected',
} as const;

export type UserChoice = (typeof UserChoice)[keyof typeof UserChoice];
